export const ACCESS_DENIED_EVENT =
  "admin-access-denied";

export const emitAccessDenied = ({
  message,
  pageName,
  action,
} = {}) => {
  window.dispatchEvent(
    new CustomEvent(ACCESS_DENIED_EVENT, {
      detail: {
        message:
          message ||
          "You do not have permission to perform this action.",

        pageName: pageName || null,
        action: action || null,
      },
    })
  );
};